import React from "react";

const Navbar4Brand = ({ onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group flex min-w-0 items-center gap-4 text-left"
      aria-label="Retour à l’accueil"
    >
      <span className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-slate-200 transition-transform duration-200 group-hover:scale-[1.03] dark:bg-white/10 dark:ring-white/10">
        <img
          src="/img/logo_judocoach_pro_512.png"
          alt="Judo Coach Pro"
          className="h-full w-full object-contain p-1"
        />
      </span>

      <span className="flex min-w-0 flex-col justify-center">
        <span className="truncate font-heading text-[1.50rem] font-bold leading-[1.02] tracking-tight text-slate-950 dark:text-white">
          Judo Coach Pro
        </span>

        <span className="mt-1 text-[0.78rem] font-light capitalize tracking-[0.16em] text-slate-500 dark:text-white/55">
          Carnet de performances
        </span>
      </span>
    </button>
  );
};

export default Navbar4Brand;